<template>
	
  <div class="p-grid">
    <div class="p-col">
      <div v-if="loading" role="status" class="p-mt-1">
        {{$t('details.alarm_load_message')}}
      </div>
      <div v-else-if="error" role="alert" class="p-mt-1">
        {{$t('details.alarm_load_error')}}
      </div>
      <ScrollPanel v-else-if="alarmsData" class="alarms-scrollpanel" style="width: 100%; height: 370px; padding-left: 0;">
        <Accordion class="alarm-accordion" :activeIndex="[0]" :multiple="true" expandIcon="p-accordion-toggle-icon pi pi-chevron-down" collapseIcon="p-accordion-toggle-icon pi pi-chevron-up">
              <AccordionTab v-for="(value, name) in alarmsData" :key="name">
                  <template #header>
                      <span class="icon-calendar" style="font-size: 20px; margin-right: .8rem;"/>
                      <span>{{formatDate(name)}}</span>
                  </template>
                  <div v-for="alarm in value" :key="alarm.timestamp" :class="['alarm',{'alarm-inactive':!alarm.active}]">
                    <img v-if="alarm.active" src="assets/irinox/icons/alarm_active.svg" :alt="$t('common.active')"/> 
                    <img v-else src="assets/irinox/icons/alarm_inactive.svg" :alt="$t('common.inactive')"/>
                    <span class="alarm-name">{{alarm.name?$t('alarms.'+alarm.name):"-"}}</span>
                    <span class="alarm-code">&nbsp;({{alarm.name}})</span>
                    <span class="alarm-time">{{formatTime(alarm.timestamp)}}</span> 
                  </div>
              </AccordionTab>
        </Accordion>
      </ScrollPanel>
      <div v-else class="p-mt-1">
        {{$t('details.no_alarm_found')}}
      </div>
    </div>
  </div>

</template>

<script>
// import AlarmAccordion from "../AlarmAccordion.vue";
import { mapGetters } from 'vuex';
import ApplianceService from '../../service/ApplianceService';

export default {
    components: {
      // AlarmAccordion,
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          alarmsData: null,
          loading: false,
          error: false,
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          is24hour: 'userdata/is24hour',
        }),
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.loadAlarms();
    },
    methods: {
      loadAlarms() {
        this.loading = true;
        this.error = false;
        this.alarmsData = null;
        this.applianceService.getAlarms(this.personaltoken, this.serialNumber)
          .then(data => {
            if (data.code == "200") {
              let alarms = data.body;
              if (alarms != null && alarms.length > 0) {
                alarms.sort((a, b) => this.$functions.compareNumbers(a, b, "timestamp"));
                let aObj = {};
                for (let i = 0; i < alarms.length; i++) {
                  let key = this.$functions.utcDate(alarms[i].timestamp, 1000).toISOString().slice(0, 10);
                  if (aObj[key] == null) {
                    aObj[key] = [];
                  }
                  aObj[key].push(alarms[i]);
                }
                this.alarmsData = aObj;
              }
            } else {
              console.error(JSON.stringify(data));
              this.error = true;
            }
          })
          .catch(err => {
            console.error(err);
            this.error = true;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      formatDate(name) {
        try {
          return this.$d(new Date(name), "medium");
        } catch(err) {
          console.error(err);
          return "Invalid date";
        }
      },
      formatTime(timestamp) {
        try {
          if(this.is24hour) {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time");
          } else {
            return this.$d(this.$functions.utcDate(timestamp,1000), "time12");
          }
        } catch(err) {
          console.error(err);
          return "N/A";
        }
      }
    }
}
</script>

<style >



</style>